import React from 'react';
import Dropdown from '@common/components/dropdown';
import Icon from '@common/components/icon';
import Confirm from '@common/components/confirm-button';
import { useTranslation } from 'react-i18next';

interface SectionHeaderProps {
  courseTitle: string;
  courseDescription: string;
  onEditClick: () => void;
  onDeleteClick?: () => void;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({
  courseTitle,
  courseDescription,
  onEditClick,
  onDeleteClick,
}) => {
  const { t } = useTranslation();

  return (
    <div className="tw-flex tw-flex-row tw-mb-6 tw-relative">
      <div className="tw-flex tw-flex-col tw-gap-2 tw-w-full">
        <div className="tw-text-xl tw-font-semibold tw-text-gray-900">
          {courseTitle}
        </div>
        <div className="tw-flex tw-flex-row tw-gap-1 tw-justify-between">
          <div className="tw-text-sm tw-text-gray-muted tw-font-inter tw-font-semibold">
            {courseDescription}
          </div>
          <Dropdown
            className="MembershipRowDropdown"
            alignRight
            toggle={<Icon type="more_horiz" size={20} />}
          >
            <Dropdown.Item icon="edit__filled" onClick={onEditClick}>
              {t('learning:section_header_edit')}
            </Dropdown.Item>
            {onDeleteClick && (
              <Confirm
                title={t('learning:section_header_delete_title')}
                description={t('learning:section_header_delete_description')}
                onConfirm={onDeleteClick}
                danger
              >
                <Dropdown.Item icon="delete__filled">
                  {t('learning:section_header_delete')}
                </Dropdown.Item>
              </Confirm>
            )}
          </Dropdown>
        </div>
      </div>
    </div>
  );
};

export default SectionHeader;
